// extracted by mini-css-extract-plugin
module.exports = {"root":"common_root__1sk1L","left":"common_left__1jmFd","table":"common_table__H7eVX","tableActions":"common_tableActions__1xzhN","pageTitle":"common_pageTitle__oq6iO"};